import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { GeneralServices } from '../services/general-services';
import { ILocation, ILocationToSend } from '../Interfaces/ILocation';

@Injectable({
    providedIn: 'root',
})
export class LocationsService extends RestCallService {
    public dataToSend: ILocationToSend = {
        pkLocation: 0,
        location: '',
        pkSelectedSite: 0,
        fkSite: 0
    };

    constructor(
        public httpClient: HttpClient,
        private generalServices: GeneralServices,
        public toastr: ToastrService,
        public notificationService: NotificationService,
        public translate: TranslateApplicationService,
    ) {
        super(
            httpClient,
            'API_Benefits',
            toastr,
            notificationService,
            translate,
        );
    }

    public GetAll() {
        this.generalServices.ValidateCognito();
        this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
        return this.post<ILocation[]>(
            '/api/Locations/GetAll', 
            this.dataToSend
        );
    }

    public GetAvailable() {
        this.generalServices.ValidateCognito();
        this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));

        return this.post<ILocation[]>(
            '/api/Locations/GetAvailable', 
            this.dataToSend
        );
    }

    public GetFromWD(){
        this.generalServices.ValidateCognito();
        this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));

        return this.post<string[]>(
            '/api/Locations/GetFromWD', 
            this.dataToSend
        );
    }

    public GetByName(location: string) {
        this.generalServices.ValidateCognito();
        if(localStorage.getItem('fksite')){
            this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
        }
        this.dataToSend.location = location;

        return this.post<ILocation[]>(
            '/api/Locations/GetByName', 
            this.dataToSend
        );
    }

    public Create(data: any) {
        this.generalServices.ValidateCognito();
        this.dataToSend.location = data.cbLocation;
        this.dataToSend.pkSelectedSite = data.cbSite;
        this.dataToSend.fkSite = parseInt(localStorage.getItem('fksite'));
        return this.post('/api/Locations/Create', this.dataToSend);
    }

    public Update(data: any) {
        this.generalServices.ValidateCognito();
        this.dataToSend.pkLocation = data.pkLocation;
        this.dataToSend.location = data.cbLocation;
        this.dataToSend.pkSelectedSite = data.cbSite;
        this.dataToSend.fkSite = parseInt( localStorage.getItem('fksite') );
        return this.put('/api/Locations/Update', this.dataToSend);
    }

    public ChangeStatus(data: any) {
        this.generalServices.ValidateCognito();
        this.dataToSend.pkLocation = data.pk_location;
        this.dataToSend.fkSite = parseInt( localStorage.getItem('fksite') );
        return this.put('/api/Locations/ChangeStatus', this.dataToSend);
    }
}
